<script setup lang="ts">
import type { MenuListItem } from '@/constants/menuLists';

import SecondarySideBarMenuVListItem from '@/components/items/SecondarySideBarMenuVListItem.vue';
import { useAuthStore } from '@/stores/useAuthStore';

export interface Props {
  list?: readonly MenuListItem[];
}
const props = withDefaults(defineProps<Props>(), {});

const authStore = useAuthStore();
</script>

<template>
  <v-list
    :class="$style.secondarySideBarMenuVList"
    data-testid="secondarySideBarMenuVList"
  >
    <template v-for="item in props.list" :key="item.title">
      <template v-if="!item.staff || authStore.isStaff">
        <SecondarySideBarMenuVListItem
          :prepend-icon="item.icon"
          :to="!item.disabled ? item.to : undefined"
          :disabled="item.disabled || !item.to"
        >
          {{ item.title }}
        </SecondarySideBarMenuVListItem>
      </template>
    </template>
  </v-list>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.secondarySideBarMenuVList {
  font-size: 1rem;
  line-height: 24px;
  padding: 8px 0px !important;
}
</style>
